import { render, staticRenderFns } from "./S3FilesUpload.vue?vue&type=template&id=30af3ed1&"
import script from "./S3FilesUpload.vue?vue&type=script&lang=js&"
export * from "./S3FilesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports